import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.admin');
import { OnInit, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'wiz-component-nav-admin',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.admin/view.scss */
/* src/app/component.nav.admin/view.scss: no such file or directory */`],
})
export class ComponentNavAdminComponent implements OnInit {
    constructor(@Inject( Service)         public service: Service,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef)         private cdr: ChangeDetectorRef) { }

    // public comm_menus = [
    //     { label: '정보', path: 'info', icon: 'Info' },
    //     { label: '연구그룹', path: 'group', icon: 'Group' },
    //     { label: '연구자', path: 'user', icon: 'User' }
    // ]
    public communityID: string | null = null;
    public groupID: string | null = null;
    public isGroupContext = false;
    public groupName: string | null = null;

    // 메뉴 세트 분리
    public comm_menus_community = [
        { label: '정보', path: 'info', icon: 'Info' },
        { label: '연구그룹', path: 'group', icon: 'Group' },
        { label: '연구자', path: 'user', icon: 'User' }
    ];

    public comm_menus_group = [
        { label: '정보', path: 'info', icon: 'Info' },
        { label: '연구자', path: 'user', icon: 'User' }
    ];

    public comm_menus = this.comm_menus_community; // 기본값


    public showCommSubmenu = true;
    public selectedCommunity: any;

    public adminMenu = [
        { id: 'community-mgmt', label: '커뮤니티 관리', icon: 'Building', mainPath: '/admin/community', path: '/admin/community', category: 'management' },
        { id: 'ticket-mgmt', label: '티켓팅 관리', icon: 'Ticket', mainPath: '/admin/ticketing', path: '/admin/ticketing', category: 'management' },
        { id: 'faq-mgmt', label: 'FAQ 관리', icon: 'Question', mainPath: '/admin/faq', path: '/admin/faq', category: 'management' },
        { id: 'notice-mgmt', label: '공지사항 관리', icon: 'Megaphone', mainPath: '/admin/notice', path: '/admin/notice', category: 'management' },
        { id: 'manual-mgmt', label: '매뉴얼 관리', icon: 'FileLines', mainPath: '/admin/manual', path: '/admin/manual', category: 'management' },
        { id: 'image-mgmt', label: '매뉴얼 이미지 관리', icon: 'Image', mainPath: '/admin/image', path: '/admin/image', category: 'management' },
        { id: 'research-mgmt', label: '성과 관리', icon: 'Chart', mainPath: '/admin/research', path: '/admin/research', category: 'management' },
        { id: 'board-mgmt', label: '게시판 관리', icon: 'Message', mainPath: '/admin/board', path: '/admin/board', category: 'management' },
        { id: 'storage-mgmt', label: '스토리지 관리', icon: 'Storage', mainPath: '/admin/storage', path: '/admin/storage', category: 'management' },
        { id: 'request-mgmt', label: '승인 요청 관리', icon: 'Envelope', mainPath: '/admin/request', path: '/admin/request', category: 'management' },
        { id: 'user-mgmt', label: '사용자 관리', icon: 'Users', mainPath: '/admin/users', path: '/admin/users', category: 'management' },
        { id: 'mypage', label: '마이페이지', icon: 'User', mainPath: '/mypage', path: '/mypage', category: 'management' },
        { id: 'password', label: '비밀번호 변경', icon: 'Key', mainPath: '/admin/password', path: '/admin/password', category: 'management' }
    ];

    public categories = {
        management: { label: '관리', colorClass: 'text-gray-700' },
        // settings: { label: '설정', colorClass: 'text-gray-700' },
        // others: { label: '기타', colorClass: 'text-gray-700' }
    };
    public categoryKeys = Object.keys(this.categories);
    public collapsedCategories: any = {};

    public session: any;
    public mode: any;

    public community_link: string = '/admin/community';

    public userInfo: any = {
        account_name: '',
        email: '',
        roles: [],
        community_manager: false
    };

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.membership("admin", "/");
        this.session = this.service.auth.session;
        await this.roles();
        if (this.session.role !== 'admin') this.adminMenu = this.adminMenu.filter(item => item.id !== 'user-mgmt');
        if (!this.userInfo.community_manager) this.adminMenu = this.adminMenu.filter(item => item.id !== 'request-mgmt');

        if (this.session?.role === 'admin') {
            this.community_link = '/admin/community';
        } else {
            this.community_link = `/admin/community/${this.session.community_id}/info`;
            this.adminMenu = this.adminMenu.filter(item => item.id !== 'user-mgmt');
        }

        await this.service.render();

        // ✅ URL 변경 반응
        this.navSub = this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe(() => {
                // 비동기지만 기다릴 필요는 없음
                this.updateFromUrl();
            });

        // 초기 실행
        await this.updateFromUrl();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.navSub?.unsubscribe();
    }

    public async roles() {
        const { code, data } = await wiz.call("roles");
        if (code != 200) return await this.service.alert.error("Error!");
        this.userInfo = data;
        await this.service.render();
    }

    private async updateFromUrl() {
        const url = this.router.url;

        if (url.includes('/admin/community/')) {
            const segments = url.split('/').filter(Boolean);
            const idx = segments.indexOf('community');
            const after = segments.slice(idx + 1);
            // after 예시
            // 커뮤니티: [communityID, menu] → ["123", "info"]
            // 그룹:     [communityID, groupID, menu] → ["123", "G1", "info"]

            const communityID = after[0] || null;
            let groupID: string | null = null;
            let mode: string | null = null;

            const communityMenus = ['info', 'group', 'user'];
            const groupMenus = ['info', 'user'];

            // 그룹 컨텍스트 판단
            if (after.length >= 3 && groupMenus.includes(after[2])) {
                groupID = after[1];
                mode = after[2];
                this.isGroupContext = true;
                this.comm_menus = this.comm_menus_group;
                const { code, data } = await wiz.call("group", { id: groupID });
                this.groupName = data;
            } else {
                groupID = null;
                mode = after[1] || null;
                this.isGroupContext = false;
                this.comm_menus = this.comm_menus_community;
            }

            const changed =
                this.communityID !== communityID ||
                this.groupID !== groupID ||
                this.mode !== mode;

            this.communityID = communityID;
            this.groupID = groupID;
            this.mode = mode;

            if (changed && this.communityID) {
                const { code, data } = await wiz.call("load", { id: this.communityID });
                if (code === 200 && data) {
                    this.selectedCommunity = data.name;
                    this.showCommSubmenu = true;
                } else {
                    this.selectedCommunity = null;
                    this.showCommSubmenu = false;
                    if (this.communityID != 'new') await this.service.alert.error("커뮤니티 정보를 불러올 수 없습니다.");
                }
                this.cdr.detectChanges();
            }
        } else {
            this.communityID = null;
            this.groupID = null;
            this.mode = null;
            this.selectedCommunity = null;
            this.showCommSubmenu = false;
        }

        await this.service.render();
    }

    // private async updateFromUrl() {
    //     const url = this.router.url;

    //     if (url.includes('/admin/community/')) {
    //         const segments = url.split('/').filter(Boolean);
    //         const idx = segments.indexOf('community');
    //         const communityID = segments[idx + 1] || null;
    //         const mode = segments[idx + 2] || null;

    //         const changed = this.communityID !== communityID || this.mode !== mode;
    //         this.communityID = communityID;
    //         this.mode = mode;
    //         if (changed) {
    //             // 🔥 서버에 communityID로 기관 정보 요청
    //             const { code, data } = await wiz.call("load", { id: this.communityID });
    //             if (code === 200 && data) {
    //                 this.selectedCommunity = data.name;
    //                 this.showCommSubmenu = true;
    //                 await this.service.render();
    //             } else {
    //                 this.selectedCommunity = null;
    //                 this.showCommSubmenu = false;
    //                 await this.service.alert.error("커뮤니티 정보를 불러올 수 없습니다.");
    //             }
    //             this.cdr.detectChanges();
    //         }
    //     } else {
    //         this.communityID = null;
    //         this.mode = null;
    //         this.selectedCommunity = null;
    //         this.showCommSubmenu = false;
    //         await this.service.render();
    //     }
    //     await this.service.render();
    // }

    public toggleCategory(category: string) {
        this.collapsedCategories = {
            ...this.collapsedCategories,
            [category]: !this.collapsedCategories[category]
        };
    }

    public getAdminItemsBy(categoryKey: string) {
        return this.adminMenu.filter(i => i.category === categoryKey);
    }

    // public isActive(link: string) {
    //     return location.pathname.indexOf(link) === 0
    // }
    public isActive(link: string | string[]) {
        const path = location.pathname;
        const links = Array.isArray(link) ? link : [link];
        return links.some(l => path.startsWith(l));
    }

    // lucide 이름 → Tabler 아이콘 클래스 매핑
    public getIconClass(iconName: string) {
        const map = {
            User: 'fa-solid fa-user',
            Users: 'fa-solid fa-users',
            Ticket: 'fa-solid fa-ticket',
            Settings: 'fa-solid fa-gear',
            LogOut: 'fa-solid fa-right-from-bracket',
            ChevronDown: 'fa-solid fa-chevron-down',
            Grip: 'fa-solid fa-grip',
            Clipboard: 'fa-solid fa-clipboard',
            Question: 'fa-solid fa-clipboard-question',
            FileLines: 'fa-solid fa-file-lines',
            Group: 'fa-solid fa-users-viewfinder',
            Rectangle: 'fa-solid fa-users-rectangle',
            Wrench: 'fa-solid fa-screwdriver-wrench',
            Chart: 'fa-solid fa-chart-column',
            Envelope: 'fa-solid fa-envelope-circle-check',
            Bars: 'fa-solid fa-bars',
            Megaphone: 'fa-solid fa-bullhorn',
            Building: 'fa-solid fa-building',
            Info: 'fa-solid fa-circle-info',
            Message: 'fa-solid fa-message',
            Storage: 'fa-solid fa-box',
            Image: 'fa-solid fa-image',
            Key: 'fa-solid fa-key'
        };
        return map[iconName] || 'fa-solid fa-circle';
    }

    public async logout() {
        sessionStorage.clear();
        window.location.href = '/auth/logout';
    }
}

export default ComponentNavAdminComponent;